import React from 'react';
import Button from 'fuse-ui/components/Button';
import PropTypes from 'prop-types';
import TextArea from 'fuse-ui/components/TextArea';
import { withStyles } from '@material-ui/core/styles';

import Modal from './modal';

const styles = theme => ( {
    button: {
        margin: theme.spacing.unit,
    }
} );

class ModalNotes extends React.Component{
    state = {
        note: '',
    };

    onChange = ( event ) => {
        this.setState( { note: event.target.value } );
    };

    render(){
        const {
            classes,
            title,
            subtitle,
            open,
            onClose,
            onSave,
            errorMessage,
            isLoading,
            dataAutomationId,
        } = this.props;
        const { note } = this.state;

        const saveNote = () => {
            onSave( note );
        };

        const actions = (
            <>
                <Button onClick={onClose} variant="text" className={classes.button} data-automation-id={`${dataAutomationId}-cancel-btn`}>
                    Cancel
                </Button>
                <Button onClick={saveNote} color="primary" className={`${classes.button}`} data-automation-id={`${dataAutomationId}-save-btn`} disabled={isLoading || note.length === 0}>
                    Save
                </Button>
            </>
        );

        return (
            <Modal
                open={open}
                onClose={onClose}
                title={title}
                subTitle={subtitle}
                modalActions={actions}
                dataAutomationId={dataAutomationId}
            >
                <TextArea
                    autoFocus={true}
                    data-automation-id="notes-text-area"
                    label="Notes"
                    placeholder="Enter notes here."
                    onChange={this.onChange}
                    error={errorMessage.length > 0}
                    maxLength={ 20}
                    fullWidth
                    helperText={errorMessage}
                />
            </Modal>
        );
    }
};

ModalNotes.propTypes = {
    classes: PropTypes.object.isRequired,
    dataAutomationId: PropTypes.string.isRequired,
    errorMessage: PropTypes.string,
    isDisabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    onChange: PropTypes.func,
    onClose: PropTypes.func,
    onSave: PropTypes.func,
    open: PropTypes.bool.isRequired,
    subtitle: PropTypes.string,
    title: PropTypes.string,
};

ModalNotes.defaultProps = {
    errorMessage: '',
    onChange: () => {},
    onClose: () => {},
    onSave: () => {},
    title: 'Add Notes'
};

export default withStyles( styles )( ModalNotes );
